// extracted by mini-css-extract-plugin
export default {"container":"G_bbAq","vet":"YpASno","icon":"vXPfT1","name":"iUy1yh","quote":"Z53YCv"};